import { render } from "./person-list.vue?vue&type=template&id=dfe0aff8"
import script from "./person-list.vue?vue&type=script&lang=js"
export * from "./person-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__